var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import 'reflect-metadata';
import { Component, Vue } from 'vue-property-decorator';
import startCase from 'lodash/startCase';
var formatAmount = require("../../../../lib/formatAmount").formatAmount;
import Loader from "@/components/loader.vue";
import NotFound from "@/components/notfound.vue";
import AccountCard from "@/components/accountcard.vue";
import CreateReservedAccount from '../CreateReservedAccount.vue';
import CreateAccountModal from './createmodal.vue';
import EditAccountModal from './edit.vue';
import * as VuxStore from 'vuex-class';
import { getCompanyLogo } from "../../../../lib/utils";
var Store = VuxStore.namespace('ts');
var BankAccount = /** @class */ (function (_super) {
    __extends(BankAccount, _super);
    function BankAccount() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.createAccountModal = false;
        _this.editAccountModal = false;
        _this.accounts = [];
        _this.getAccount = null;
        _this.startCase = startCase;
        _this.makePrimary = '';
        return _this;
    }
    BankAccount.prototype.mounted = function () {
        var activeTab = this.$route.hash.replace('#/', '').toLowerCase();
        this.fetchDashboardBankAccounts(this.$route.params.id);
    };
    BankAccount.prototype.onAccountSelected = function (account) { };
    BankAccount.prototype.onEditAccount = function (account) {
        this.getAccount = account;
        this.toggleEditAccountModal();
    };
    BankAccount.prototype.setAccountAsPrimary = function (account, command) {
        if (command === void 0) { command = null; }
        console.log(account, account.id);
        this.makePrimary = command || account.id;
        var account_type = 'BANK';
        if (account.vnuban) {
            account_type = 'VIRTUAL';
        }
        this.createReserve({ name: account.account_name, isPrimary: !command, account_id: account.id, command: command, account_type: account_type });
    };
    BankAccount.prototype.getLogo = function (code, defaultValue) {
        if (code === void 0) { code = 'any'; }
        if (defaultValue === void 0) { defaultValue = null; }
        var bank = this.$store.state.bankNames[code];
        var name = bank
            ? bank.name || bank.bank_short_name
            : defaultValue || "Not Available";
        return getCompanyLogo(name);
    };
    Object.defineProperty(BankAccount.prototype, "getters", {
        get: function () {
            return this.$store.getters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BankAccount.prototype, "commit", {
        get: function () {
            return this.$store.commit;
        },
        enumerable: false,
        configurable: true
    });
    BankAccount.prototype.toggleCreateAccountModal = function () {
        this.createAccountModal = !this.createAccountModal;
    };
    BankAccount.prototype.toggleEditAccountModal = function () {
        this.editAccountModal = !this.editAccountModal;
    };
    __decorate([
        Store.Getter
    ], BankAccount.prototype, "getDashboardBankAccounts", void 0);
    __decorate([
        Store.Action
    ], BankAccount.prototype, "fetchDashboardBankAccounts", void 0);
    __decorate([
        Store.Action
    ], BankAccount.prototype, "createNewAccount", void 0);
    __decorate([
        Store.Action
    ], BankAccount.prototype, "createReserve", void 0);
    BankAccount = __decorate([
        Component({
            name: 'BankAccount',
            components: {
                Loader: Loader,
                CreateReservedAccount: CreateReservedAccount,
                NotFound: NotFound,
                AccountCard: AccountCard,
                CreateAccountModal: CreateAccountModal,
                EditAccountModal: EditAccountModal
            },
        })
    ], BankAccount);
    return BankAccount;
}(Vue));
export default BankAccount;
